var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductCodes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_216029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49902 14C6.22302 14 5.99902 13.776 5.99902 13.5V8.5C5.99902 8.224 6.22302 8 6.49902 8C6.77502 8 6.99902 8.224 6.99902 8.5V13.5C6.99902 13.776 6.77502 14 6.49902 14Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49902 12C8.22302 12 7.99902 11.776 7.99902 11.5V8.5C7.99902 8.224 8.22302 8 8.49902 8C8.77502 8 8.99902 8.224 8.99902 8.5V11.5C8.99902 11.776 8.77502 12 8.49902 12Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.499 11C12.223 11 11.999 10.776 11.999 10.5V8.5C11.999 8.224 12.223 8 12.499 8C12.775 8 12.999 8.224 12.999 8.5V10.5C12.999 10.776 12.775 11 12.499 11Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.499 10.5C14.223 10.5 13.999 10.276 13.999 10V8.5C13.999 8.224 14.223 8 14.499 8C14.775 8 14.999 8.224 14.999 8.5V10C14.999 10.276 14.775 10.5 14.499 10.5Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.499 11C16.223 11 15.999 10.776 15.999 10.5V8.5C15.999 8.224 16.223 8 16.499 8C16.775 8 16.999 8.224 16.999 8.5V10.5C16.999 10.776 16.775 11 16.499 11Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.499 12C10.223 12 9.99902 11.776 9.99902 11.5V8.5C9.99902 8.224 10.223 8 10.499 8C10.775 8 10.999 8.224 10.999 8.5V11.5C10.999 11.776 10.775 12 10.499 12Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49902 14C8.22302 14 7.99902 13.776 7.99902 13.5C7.99902 13.224 8.22369 13 8.49902 13H9.49902C9.77502 13 9.99902 13.224 9.99902 13.5C9.99902 13.776 9.77502 14 9.49902 14H8.49902Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49902 8C4.22302 8 3.99902 7.776 3.99902 7.5V6.52467C3.99902 5.684 4.68302 5 5.52369 5H6.49902C6.77502 5 6.99902 5.224 6.99902 5.5C6.99902 5.776 6.77502 6 6.49902 6H5.52369C5.23436 6 4.99902 6.23533 4.99902 6.52467V7.5C4.99902 7.776 4.77502 8 4.49902 8Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.499 8C18.223 8 17.999 7.776 17.999 7.5V6.52467C17.999 6.23533 17.7637 6 17.4744 6H16.499C16.223 6 15.999 5.776 15.999 5.5C15.999 5.224 16.2237 5 16.499 5H17.4744C18.315 5 18.999 5.684 18.999 6.52467V7.5C18.999 7.776 18.775 8 18.499 8Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52369 17C4.68302 17 3.99902 16.316 3.99902 15.4753V14.5C3.99902 14.224 4.22302 14 4.49902 14C4.77502 14 4.99902 14.224 4.99902 14.5V15.4753C4.99902 15.7647 5.23436 16 5.52369 16H6.49902C6.77502 16 6.99902 16.224 6.99902 16.5C6.99902 16.776 6.77502 17 6.49902 17H5.52369Z",
    fill: "#32CFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.499 21C19.3657 21 19.2397 20.948 19.1457 20.8533L16.9504 18.658C16.2497 19.2027 15.3884 19.5 14.499 19.5C12.2937 19.5 10.499 17.7053 10.499 15.5C10.499 13.2947 12.2937 11.5 14.499 11.5C16.7044 11.5 18.499 13.2947 18.499 15.5C18.499 16.3887 18.2017 17.2507 17.657 17.9513L19.8524 20.1467C20.047 20.3413 20.047 20.6587 19.8524 20.854C19.7584 20.948 19.633 21 19.499 21ZM14.499 12.5C12.845 12.5 11.499 13.846 11.499 15.5C11.499 17.154 12.845 18.5 14.499 18.5C16.153 18.5 17.499 17.154 17.499 15.5C17.499 13.846 16.1537 12.5 14.499 12.5Z",
    fill: "#32CFDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_216029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCodes);
export default __webpack_public_path__ + "static/media/product-codes.51e7f872.svg";
export { ForwardRef as ReactComponent };